import { Component, Input, SimpleChanges } from '@angular/core';
import { TICKET_STATUS } from '@shared/enum/booking.enum';
import { getBookingStatusKey, getBookingStatusStyle } from '@shared/utils/helper';

@Component({
  selector: 'booking-info',
  templateUrl: './booking-info.component.html',
  styleUrls: ['./booking-info.component.scss']
})
export class BookingInfoComponent {
  @Input() flightDetail: any;
  @Input() currentModeView: any;

  isShowPinCode: boolean = false;
  bookingStatus: string = '';
  bookingStatusStyle: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['flightDetail'] && changes['flightDetail'].currentValue) {
      this.bookingStatus = getBookingStatusKey(this.flightDetail?.booking_info?.booking_status);
      this.bookingStatusStyle = getBookingStatusStyle(this.flightDetail?.booking_info?.booking_status);
    }
  }

  handleColorTicketStatus(status: string) {
    if (status) {
      const ticketStatus = status?.toUpperCase();
      switch (ticketStatus) {
        case 'HOLD':
          return 'text-palette-yellow-600 bg-palette-yellow-50';
        case 'EXPIRED':
          return 'bg-palette-red-50 text-palette-red-600';
        case 'TICKETING':
          return 'text-palette-blue-700 bg-palette-blue-50';
        case "TICKETED":
          return 'bg-palette-green-50 text-palette-green-600';
        default:
          return 'text-palette-red-600 bg-palette-red-50';
      }
    }
    return ''

  }

  getTicketStatus(status: string): string {
    switch (status) {
      case TICKET_STATUS.HOLD:
        return "COMMON.TICKET_STATUS.HOLD";
      case TICKET_STATUS.EXPIRED:
        return "COMMON.TICKET_STATUS.EXPIRED";
      case TICKET_STATUS.TICKETED:
        return "COMMON.TICKET_STATUS.TICKETED";
      case TICKET_STATUS.TICKETING:
        return "COMMON.TICKET_STATUS.TICKETING";
      default:
        return status;
    }
  }

  hidePinCode(pinCode: string) {
    return pinCode?.replace(/./g, '•');
  }

  togglePinCode() {
    this.isShowPinCode = !this.isShowPinCode;
  }

  getSourceOrderId(sourceOrderId: any) {
    if (sourceOrderId && sourceOrderId.toUpperCase() != 'FAILED') {
      return sourceOrderId
    }
    return ""
  }
}